module.exports = __webpack_public_path__ + "static/assets/f0c98e9ae97caf1c0920ba53bf4e4b91.svg";